import { render, staticRenderFns } from "./YaoShiDetail.vue?vue&type=template&id=24975ad9&scoped=true"
import script from "./YaoShiDetail.vue?vue&type=script&lang=js"
export * from "./YaoShiDetail.vue?vue&type=script&lang=js"
import style0 from "./YaoShiDetail.vue?vue&type=style&index=0&id=24975ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24975ad9",
  null
  
)

export default component.exports